import { render, staticRenderFns } from "./ShameMarkContent.vue?vue&type=template&id=d890a528&scoped=true&"
import script from "./ShameMarkContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ShameMarkContent.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ShameMarkContent.vue?vue&type=style&index=0&id=d890a528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d890a528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d890a528')) {
      api.createRecord('d890a528', component.options)
    } else {
      api.reload('d890a528', component.options)
    }
    module.hot.accept("./ShameMarkContent.vue?vue&type=template&id=d890a528&scoped=true&", function () {
      api.rerender('d890a528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/shame-mark/ShameMarkContent/ShameMarkContent.vue"
export default component.exports